module.exports = __webpack_public_path__ + "img/sh001-001.24e35d40.jpg";